import React, { Component } from 'react';
import ApiManager from '../../../apiManager';
import Loading from '../../Fragments/Loading';
import ErrorModal from '../../Fragments/ErrorModal';
import {setBracketsAfterFirstPart, trans} from '../../../helpers';
import config from '../../../baseConfig';
import { Link } from 'react-router-dom';
import Modal from '../../Fragments/Modal';

class B2bCuratorList extends Component {

    constructor( props ){
        super( props );

        this.state = {
            curatorList: '',
            filterVal: '',
            filterValForSearch: '',
            scrollShowItemsDef: 10,
            scrollShowItems: 10,
            scrollLimit: 10,
            scrollItemCount: 0,
            removeItemName: '',
            removeItemId: '',
            removeButtonLoading: false,
            removeModal: false,
            removeModalButtonDisabled: false,
            showErrorModal: false
        };

        // Component props
        this.componentIsMounted = true;

        // Bind own methods
        this.curatorListSuccess = this.curatorListSuccess.bind(this);
        this.removeCancelAction = this.removeCancelAction.bind(this);
        this.removeAgreeAction = this.removeAgreeAction.bind(this);
        this.errorCallBack = this.errorCallBack.bind(this);

    }

    componentWillUnmount(){

        this.componentIsMounted = false;

    }

    initAsyncCalls(){

        // Get curator list
        ApiManager.getRequest({
            jwt: this.props.getDecryptedToken()
        }, '/b2b' + this.props.curator + '/curator').then(this.curatorListSuccess, this.errorCallBack);

    }

    componentDidMount(){

        this.initAsyncCalls();

    }

    curatorListSuccess( resolve ){

        if ( !this.componentIsMounted ) {
            return false;
        }

        // @test
        // resolve.data = { "status": "OK", "data": { "curators": [ { "id": 11, "first_name": "Garik", "last_name": "Tadevosyan", "contact_number": "7495494340", "email": "garik@gmail.com", "status": "new", "hash": null, "inn": "00025840", "creator_id": 7, "creator_type": "admin", "sort_order": 0, "show_status": "1" }, { "id": 12, "first_name": "Garik", "last_name": "Tadevosyan", "contact_number": "7495494340", "email": "garikkkkk@gmail.com", "status": "new", "hash": null, "inn": "00025840", "creator_id": 7, "creator_type": "admin", "sort_order": 0, "show_status": "1" }, { "id": 13, "first_name": "Garik", "last_name": "Tadevosyan", "contact_number": "7495494340", "email": "garikkkkkk@gmail.com", "status": "new", "hash": null, "inn": "00025840", "creator_id": 7, "creator_type": "admin", "sort_order": 0, "show_status": "1" }, { "id": 14, "first_name": "Garik", "last_name": "Tadevosyan", "contact_number": "7495494340", "email": "garikkkkkkk@gmail.com", "status": "new", "hash": null, "inn": "00025840", "creator_id": 7, "creator_type": "admin", "sort_order": 0, "show_status": "1" }, { "id": 15, "first_name": "Garik", "last_name": "Tadevosyan", "contact_number": "7495494340", "email": "garikkkkkkkk@gmail.com", "status": "new", "hash": null, "inn": "00025840", "creator_id": 7, "creator_type": "admin", "sort_order": 0, "show_status": "1" }, { "id": 16, "first_name": "Garik", "last_name": "Tadevosyan", "contact_number": "7495494340", "email": "garikkkkkkkkk@gmail.com", "status": "new", "hash": null, "inn": "00025840", "creator_id": 7, "creator_type": "admin", "sort_order": 0, "show_status": "1" }, { "id": 17, "first_name": "Garik", "last_name": "Tadevosyan", "contact_number": "7495494340", "email": "garikkkkkkkksssw@gmail.com", "status": "new", "hash": null, "inn": "00025840", "creator_id": 7, "creator_type": "admin", "sort_order": 0, "show_status": "1" }, { "id": 18, "first_name": "Garik", "last_name": "Tadevosyan", "contact_number": "7495494340", "email": "garikkkkkkkkssddsw@gmail.com", "status": "new", "hash": null, "inn": "00025840", "creator_id": 7, "creator_type": "admin", "sort_order": 0, "show_status": "1" }, { "id": 19, "first_name": "Garik", "last_name": "Tadevosyan", "contact_number": "7495494340", "email": "garikkkkkkkdkssddsw@gmail.com", "status": "new", "hash": null, "inn": "00025840", "creator_id": 7, "creator_type": "admin", "sort_order": 0, "show_status": "1" }, { "id": 20, "first_name": "Garik", "last_name": "Tadevosyan", "contact_number": "7495494340", "email": "garikkkkkkdkdkssddsw@gmail.com", "status": "new", "hash": null, "inn": "00025840", "creator_id": 7, "creator_type": "admin", "sort_order": 0, "show_status": "1" }, { "id": 21, "first_name": "Garik", "last_name": "Tadevosyan", "contact_number": "7495494340", "email": "garik@helix.am", "status": "new", "hash": null, "inn": "00025840", "creator_id": 7, "creator_type": "admin", "sort_order": 0, "show_status": "1" }, { "id": 22, "first_name": "Karapet", "last_name": "Hakobyan", "contact_number": "7495494340", "email": "karo@helix.am", "status": "new", "hash": null, "inn": "00025840", "creator_id": 7, "creator_type": "admin", "sort_order": 0, "show_status": "1" }, { "id": 23, "first_name": "Karapet", "last_name": "Hakobyan", "contact_number": "7495494340", "email": "garoki@helix.am", "status": "new", "hash": null, "inn": "00025840", "creator_id": 7, "creator_type": "admin", "sort_order": 0, "show_status": "1" }, { "id": 24, "first_name": "Karapet", "last_name": "Hakobyan", "contact_number": "7495494340", "email": "garokin@helix.am", "status": "new", "hash": null, "inn": "00025840", "creator_id": 7, "creator_type": "admin", "sort_order": 0, "show_status": "1" } ] } };
        // resolve.data = { "status": "OK", "data": { "curators": [ { "id": 21, "first_name": "Garik", "last_name": "Tadevosyan", "contact_number": "7495494340", "email": "garik@helix.am", "status": "confirmed", "hash": null, "inn": "00025841", "allow_inn": "0", "creator_id": 7, "creator_type": "admin", "sort_order": 0, "show_status": "1", "creator": { "id": 7, "first_name": "Garik", "last_name": "Tadevosyan", "email": "garik@helix.am", "contact_number": "", "password_need_to_reset": "0", "status": "confirmed", "sort_order": 0 } }, { "id": 31, "first_name": "Karapet", "last_name": "Hakobyan", "contact_number": "7495494347", "email": "goal@test.com", "status": "new", "hash": null, "inn": "00025841", "allow_inn": "1", "creator_id": 21, "creator_type": "curator", "sort_order": 0, "show_status": "1", "creator": null } ] } };

        const data = resolve.data;
        const newState = { curatorList: data };

        if ( data.status === 'OK' && data.data.hasOwnProperty('curators') ) {
            newState['scrollItemCount'] = data.data.curators.length;
        }

        this.setState( newState );

    }

    errorCallBack( reject ){
        this.setState({ showErrorModal: true });
    }

    errorModal(){

        if ( !this.state.showErrorModal ) {
            return '';
        }

        return (
            <ErrorModal
                title={trans( this.props.b2bTrans, 'b2b.error.modal.title' )}
                description={trans( this.props.b2bTrans, 'b2b.error.modal.description' )}
                action_text={trans( this.props.b2bTrans, 'b2b.error.modal.action_text' )}
            />
        );

    }

    emptyFilter( message ){

        return (
            <tr>
                <td colSpan="7">
                    <p className="fs14 tc">{message}</p>
                </td>
            </tr>
        );

    }

    infiniteScroll( event, count ){

        if ( !this.componentIsMounted ) {
            return;
        }

        if (
            (event.target.scrollTop + event.target.offsetHeight > event.target.scrollHeight - 100) &&
            ( count > this.state.scrollShowItems )
        ) {

            this.setState({
                scrollShowItems: this.state.scrollShowItems + this.state.scrollLimit
            });
        }

    }

    doSearch( curators ){

        const pattern = new RegExp( this.state.filterValForSearch, 'i' );

        return curators.reduce(( arr, item ) => {
            if ( ( item.inn +
                   item.first_name +
                   item.last_name +
                   item.contact_number +
                   item.email +
                   item.creator_type
            ).toString().search( pattern ) > -1 ) {
                arr.push(item);
            }
            return arr;
        }, []);

    }

    filter(){

        if ( this.state.curatorList === '' ) {
            return <Loading />;
        }

        let items = this.emptyFilter( trans( this.props.b2bTrans, 'b2b.curator_list.filter_empty_result' ) ),
            profileData = this.props.profileData;

        if ( this.state.curatorList.status === 'OK' && this.state.curatorList.data.hasOwnProperty('curators') && this.state.curatorList.data.curators.length ) {

            let curators = this.state.curatorList.data.curators;

            if ( !curators.length ) {
                curators = [this.state.curatorList.data.curators];
            }

            if ( this.state.filterValForSearch ) {
                curators = this.doSearch( curators );
            }

            items = curators.reduce(( arr, item, index ) => {

                if ( index + 1 > this.state.scrollShowItems ) {
                    return arr;
                }

                let creatorFullName = item.creator_type,
                    innCell = <td className="fs14">{item.inn}</td>,
                    disabled = true;

                if ( item.hasOwnProperty('creator') && item.creator !== null ) {
                    creatorFullName = item.creator.first_name + ' ' + item.creator.last_name;
                }

                if ( profileData !== '' && profileData.status === 'OK' && profileData.data.id !== item.id ) {
                    disabled = false;
                }

                if ( this.props.curator === '' ) {
                    innCell = (
                        <td>
                            <Link
                                className="filter__link ver-top-box fs14"
                                to={
                                    config.urlPrefix +
                                    this.props.urlPrefix +
                                    '/inn/' + item.inn
                                }
                                onClick={() => {
                                    this.props.updateParentState({
                                        innVal: item.inn,
                                        innActiveBan: ''
                                    });
                                    this.props.getInnData( item.inn );
                                }}
                            >{item.inn}</Link>
                        </td>
                    );
                }

                arr.push(
                    <tr key={index}>
                        {innCell}
                        <td className="fs14">{item.first_name} {item.last_name}</td>
                        <td className="fs14">+374 {setBracketsAfterFirstPart( item.contact_number.toString().replace(/^74/, '') )}</td>
                        <td className="fs14">{item.email}</td>
                        <td className="fs14">{creatorFullName}</td>
                        <td className="filter__cell-20 tc">
                            <button
                                className="filter__edit-btn ver-top-box sprite"
                                type="button"
                                title={trans( this.props.b2bTrans, 'b2b.curator_list.edit_btn' )}
                                onClick={() => {

                                    this.props.history.push(
                                        config.urlPrefix +
                                        this.props.urlPrefix +
                                        '/editCurator/' + item.id
                                    );
                                    this.props.updatePath();

                                }}
                            >&nbsp;</button>
                        </td>
                        <td className="filter__cell-20 tc">
                            <button
                                className={`filter__remove-btn ver-top-box sprite${disabled ? ' transparent-bg' : ''}`}
                                type="button"
                                title={trans( this.props.b2bTrans, 'b2b.curator_list.remove_btn' )}
                                onClick={() => this.setState({
                                    removeModal: true,
                                    removeItemId: item.id,
                                    removeItemName: item.first_name + ' ' + item.last_name
                                })}
                                disabled={disabled}
                            >&nbsp;</button>
                        </td>
                    </tr>
                );

                return arr;

            }, []);

            if ( !items.length ) {
                items = this.emptyFilter( trans( this.props.b2bTrans, 'b2b.curator_list.filter_no_result' ) );
            }

        }

        return (
            <div className="filter">

                <div className="filter__top clear-fix">

                    <form action="#" method="post" className="form form--search" onSubmit={( event ) => {
                        event.preventDefault();
                        this.setState({
                            filterValForSearch: this.state.filterVal,
                            scrollShowItems: this.state.scrollShowItemsDef
                        });
                    }}>
                        <div className="form__form-box pr">
                            <input
                                className="form__field fs14"
                                type="text"
                                placeholder={trans( this.props.b2bTrans, 'b2b.curator_list.search.placeholder' )}
                                value={this.state.filterVal}
                                onChange={( event ) => {

                                    const newState = {
                                        filterVal: event.target.value.trim()
                                    };

                                    if ( newState.filterVal === '' ) {
                                        newState['filterValForSearch'] = '';
                                        newState['scrollShowItems'] = this.state.scrollShowItemsDef;
                                    }

                                    this.setState( newState );

                                }}
                            />
                            <button className="form__search-btn sprite" type="submit">&nbsp;</button>
                        </div>
                    </form>

                </div>

                <div className="filter__content scroller-block">
                    <table className="filter__table">
                        <thead>
                            <tr>
                                <th className="fs12">{trans( this.props.b2bTrans, 'b2b.curator_list.header_1' )}</th>
                                <th className="fs12">{trans( this.props.b2bTrans, 'b2b.curator_list.header_2' )}</th>
                                <th className="fs12">{trans( this.props.b2bTrans, 'b2b.curator_list.header_3' )}</th>
                                <th className="fs12">{trans( this.props.b2bTrans, 'b2b.curator_list.header_4' )}</th>
                                <th className="fs12">{trans( this.props.b2bTrans, 'b2b.curator_list.header_5' )}</th>
                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>{items}</tbody>
                    </table>
                </div>

            </div>
        );

    }

    removeCancelAction(){

        this.setState({
            removeModal: false,
            removeItemId: '',
            removeItemName: ''
        });

    }

    removeAgreeAction(){

        this.setState({ removeModalButtonDisabled: true });

        ApiManager.postRequest({
            _token: this.props.csrf_token.data,
            jwt: this.props.getDecryptedToken(),
            id: this.state.removeItemId
        }, '/b2b' + this.props.curator + '/curator/delete').then(( resolve ) => {

            if ( !this.componentIsMounted ) {
                return false;
            }

            // @test
            // resolve.data = { "status": "OK" };

            this.setState({ removeModalButtonDisabled: false });

            if ( resolve.data.status === 'OK' ) {
                this.setState({
                    removeModal: false,
                    removeItemId: '',
                    removeItemName: '',
                    removeSuccessModal: true,
                    curatorList: '',
                    filterVal: '',
                    filterValForSearch: '',
                    scrollShowItemsDef: 10,
                    scrollShowItems: 10,
                    scrollLimit: 10,
                    scrollItemCount: 0,
                });

                this.initAsyncCalls();

            } else {
                this.errorCallBack();
            }

        }, this.errorCallBack);

    }

    removeModal(){

        if ( !this.state.removeModal ) {
            return '';
        }

        return <Modal
            title={trans(this.props.b2bTrans, 'b2b.curator_list.remove_title')}
            htmlDescription={trans(this.props.b2bTrans, 'b2b.curator_list.remove_description').replace('%s', '<br /><b>' + this.state.removeItemName + '</b>')}
            showCancelButton={true}
            agreeText={trans(this.props.b2bTrans, 'b2b.curator_list.remove_agree')}
            cancelText={trans(this.props.b2bTrans, 'b2b.curator_list.remove_cancel')}
            agreeAction={this.removeAgreeAction}
            cancelAction={this.removeCancelAction}
            confirmButtonDisabled={this.state.removeModalButtonDisabled}
            className="modal--full"
        />;

    }

    removeSuccessModal(){

        if ( !this.state.removeSuccessModal ) {
            return '';
        }

        return <Modal
            title={trans(this.props.b2bTrans, 'b2b.curator_list.remove_success_title')}
            description={trans(this.props.b2bTrans, 'b2b.curator_list.remove_success_description')}
            agreeText={trans(this.props.b2bTrans, 'b2b.curator_list.remove_success_agree')}
            agreeAction={() => this.setState({ removeSuccessModal: false })}
            className="modal--full"
        />;

    }

    render(){

        return(
            <div className="main-wrapper__right-inner scroller-block pr" onScroll={( event ) => this.infiniteScroll( event, this.state.scrollItemCount )}>
                <div className="main-wrapper__right-top-line clear-fix">
                    <h2 className="main-wrapper__right-inner-title fb fl fs20">{trans( this.props.b2bTrans, 'b2b.curator_list.title' )}</h2>
                    <button
                        className="btn btn--yellow fs17 fr"
                        type="button"
                        onClick={() => {
                            this.props.history.push( config.urlPrefix + this.props.urlPrefix + '/createCurator' );
                            this.props.updatePath();
                        }}
                    >{trans( this.props.b2bTrans, 'b2b.curator_list.button_title' )}</button>
                </div>
                {this.filter()}
                {this.removeModal()}
                {this.removeSuccessModal()}
                {this.errorModal()}
            </div>
        );

    }

}

export default B2bCuratorList;